import { MediaType } from '../../types/MediaReference';
import { FileReference } from '../fields/FileUpload';

export const GetMediaType = (file: FileReference) => {
    if (file.localFile.type.startsWith('video/')) {
        return MediaType.Video;
    } else if (file.localFile.type.startsWith('image/')) {
        return MediaType.Image;
    } else if (!file.localFile) {
        console.error('No local file');
        return null;   
    } else {
        console.error('Media type is not supported');
        return null;
    }
}